import { Suspense } from "preact/compat";
import { Navigate, Outlet, useLocation } from "react-router";
import { categories } from "@/data/categories.js";
import { dashboards } from "@/data/dashboards.jsx";
import { getTypeSlug } from "@/util/common.js";
import CustomizePageLayout from "./customize.page-layout.jsx";

export default function DashboardPageLayout() {
  const location = useLocation();
  const { slug, type } = getTypeSlug(location.pathname);

  const dashboardInfo = dashboards[slug];

  if (dashboardInfo === undefined) {
    return <Navigate to={`/${type}`} replace={true} />;
  }

  const { name, pageName } = categories.find((category) => category.type === type);

  const parents = [{ title: pageName || name, href: `/${type}` }];

  return (
    <CustomizePageLayout {...dashboardInfo} parents={parents}>
      <Suspense fallback={null}>
        <Outlet />
      </Suspense>
    </CustomizePageLayout>
  );
}
